import * as nsfwjs from 'nsfwjs';

export default class ImageHelper {
  public static async isInappropriateContent(imageElement: HTMLImageElement): Promise<boolean> {
    const nsfwjsModel = await nsfwjs.load();
    const predictions = await nsfwjsModel.classify(imageElement);
    const INAPPROPRIATE_PREDICTIONS = [`Porn`, `Sexy`, `Hentai`];

    for(const inappropriatePrediction of INAPPROPRIATE_PREDICTIONS) {
      const probability = predictions.find(prediction => prediction.className === inappropriatePrediction)?.probability;

      if(probability && probability > 0.5) {
        return true;
      }
    }

    return false;
  }
}
